import {
  DynamicContentType,
  Sponsor,
  SponsorsData,
} from '@bm-js/atlascloud-shared'
import { isEditor } from '../utils/misc'
import { useMargin } from '../utils/hooks'
import { CText } from './CText'
import { LinkComponentType } from './CLink'
import { ResponsiveImage } from './ResponsiveImage'

type Props = {
  content: DynamicContentType<SponsorsData>
  sponsors: Sponsor[] | null
  LinkComponent: LinkComponentType
}

export const SponsorContent = ({ content, sponsors, LinkComponent }: Props) => {
  const margin = useMargin(content)

  if (!sponsors?.length) {
    if (isEditor()) {
      return <p>Du har inte lagt till några sponsorer ännu</p>
    }
    return null
  }

  return (
    <div className={`${margin}`}>
      <CText className='text-xl font-bold text-center'>
        {content.data.topText || 'Våra sponsorer'}
      </CText>
      <div className='flex flex-wrap items-center justify-center gap-x-10 gap-y-6 mt-6'>
        {sponsors.map((sponsor) => (
          <LinkComponent
            href={sponsor.url}
            target='_blank'
            rel='noopener noreferrer'
            key={sponsor._id}
            className='flex items-center justify-center h-16 w-36 @2xl/grid:h-20 @2xl/grid:w-44'
          >
            <ResponsiveImage
              className='max-h-full max-w-full object-contain'
              file={sponsor.file || undefined}
              alt={sponsor.name}
              title={sponsor.name}
            />
          </LinkComponent>
        ))}
      </div>
    </div>
  )
}
